


export default {
  props:{
    query: { type:Object, default: () => null },
  },
  watch:{
    '$props.query':{
      deep: true,
      immediate:true,
      handler(value){
        if(!!value) this.getData()
      }
    }
  },
  data: () => ({
    buttonList:[
      { label: '达人量级', value:4 },
      // { label: '自播分析', value: 1, disabled: true },
    ],
    listApiData: null,
    filter: 4,
    loading: false,
  }),
  methods: {
    getData(){
      this.loading = true
      const shopId = this.$route.params?.id
      const params = {
        ...this.$props.query,
        type: this.filter
      }
      this.$api.get(`/v2/shop/${shopId}/anchorMatrix`,{params}).
      then( res => {
        this.listApiData =res?.data
      }).
      finally(() => this.loading = false)
    }
  }
}
